import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Stack } from '@/components/ui/layout';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

function Certificates({ onUpdate, existingCertificates = [] }) {
  const [certificates, setCertificates] = useState(existingCertificates || []);


  useEffect(() => {
    onUpdate(certificates);
  }, [certificates]);

  const handleChange = (index, field, value) => {
    const updatedCertificates = [...certificates];
    updatedCertificates[index][field] = value;
    setCertificates(updatedCertificates);
  };

  const addCertificate = () => {
    setCertificates([...certificates, { name: '', issuer: '', issueDate: null }]);
  };

  const deleteCertificate = (index) => {
    const updatedCertificates = certificates.filter((_, i) => i !== index);
    setCertificates(updatedCertificates);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">Certificates</Heading>
        <Stack spacing="md">
          {certificates.map((certificate, index) => (
            <div key={index} className={cn("space-y-4 p-4 border rounded-lg")}>
              <div>
                <Label htmlFor={`certificateName${index}`}>Certificate Name</Label>
                  <Input
                    type="text"
                    id={`certificateName${index}`}
                    placeholder="Ex. Certificate Name"
                    value={certificate.name}
                    onChange={(e) => handleChange(index, 'name', e.target.value)}
                    className="mt-1"
                  />
              </div>

              <div className={cn("grid grid-cols-2 gap-4")}>
                <div>
                  <Label htmlFor={`issuer${index}`}>Issued By</Label>
                  <Input
                    type="text"
                    id={`issuer${index}`}
                    placeholder="Ex. Udemy"
                    value={certificate.issuer}
                    onChange={(e) => handleChange(index, 'issuer', e.target.value)}
                    className="mt-1"
                  />
                </div>

                <div>
                  <Label>Issue Date</Label>
                  <DatePicker
                    selected={certificate.issueDate}
                    onChange={(date) => handleChange(index, 'issueDate', date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    className={cn("w-full h-9 mt-1 px-3 py-1 text-sm border border-input rounded-md bg-background")}
                    placeholderText="Select Issue Date"
                  />
                </div>
              </div>

              <Button
                variant="ghost"
                size="sm"
                onClick={() => deleteCertificate(index)}
                className="text-destructive self-end"
              >
                <X className="w-4 h-4 mr-2" />
                Delete Certificate
              </Button>
            </div>
          ))}

          <Button variant="outline" onClick={addCertificate} className="w-full">
            Add Certificate
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default Certificates;